import { css } from '@emotion/core';
import { N900 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { flexStart, flexCenter, flexEnd, SPACE_MINIMUM } from '@/styles';

const basicResultItemWidth = 110;

export const dashboardBasicListResultRowStyles = [
  flexStart,
  css`
    a span {
      color: ${token('color.text', N900)};
      &:hover {
        text-decoration: underline;
        text-decoration-color: ${token('color.text', N900)};
      }
    }
    & > div {
      word-break: break-word;
      ${flexCenter};
      width: ${basicResultItemWidth}px;

      &:first-of-type {
        ${flexStart};
        width: calc(40% - ${(basicResultItemWidth * 2 + basicResultItemWidth * 0.6) * 0.4}px);
      }
      &:nth-of-type(2) {
        ${flexStart};
        width: calc(60% - ${(basicResultItemWidth * 2 + basicResultItemWidth * 0.6) * 0.6}px);
      }
      &:last-of-type {
        width: ${basicResultItemWidth * 0.6}px;
        ${flexEnd};
        & > span {
          margin-right: ${SPACE_MINIMUM}px;
        }
      }
    }
  `,
];

// search/team/ endpoint does not return any slo quality issues count right now,
// so we need to hide one column
export const dashboardBasicListTeamResultRowStyles = [
  css`
    & > div {
      &:first-of-type {
        width: calc(40% - ${(basicResultItemWidth + basicResultItemWidth * 0.6) * 0.4}px);
      }
      &:nth-of-type(2) {
        width: calc(60% - ${(basicResultItemWidth + basicResultItemWidth * 0.6) * 0.6}px);
      }
      &:last-of-type {
        width: ${basicResultItemWidth * 0.6}px;
      }
    }
  `,
];
